<template>
  <div @click="handleClick" :class="getClass()">
    <uwv-logo class='uwv-icon' />
    <div class='text-container'>
      <p class='sub'>Ik wil een</p>
      <p class='main'>beslissing van het UWV</p>
      <p class='sub'>over de arbeidsongeschiktheid doorgeven.</p>
    </div>
  </div>
</template>

<script>
import UwvLogo from '@aevitae/aevitaeui/0_atoms/icons/UwvLogo.vue';
import Modal from '@/shared/constants/modal';
import States from '@/resources/models/states';

export default {
  name: 'NewUwvDecisionCardButton',
  components: {
    UwvLogo
  },
  props: {
    reportOfSickness: Object
  },
  computed: {
    isAnyErrors () {
      return this.isDisabledPreviousIsReviewing ||
        !this.isPreviousApprovedOrReviewing;
    },
    isDisabledPreviousIsReviewing () {
      if (this.reportOfSickness.periods.length > 0) {
        return this.reportOfSickness.periods[this.reportOfSickness.periods.length - 1].status === States.ToReview;
      }
      return this.reportOfSickness.status === States.ToReview;
    },

    isPreviousApprovedOrReviewing () {
      if (this.reportOfSickness.periods.length > 0) {
        const period = this.reportOfSickness.periods[this.reportOfSickness.periods.length - 1];

        return period.status === States.Approved || period.status === States.Processed;
      }
      return [States.Approved, States.Processed].indexOf(this.reportOfSickness.status) > -1;
    }
  },
  methods: {
    getClass () {
      if (this.isAnyErrors) {
        return 'new-uwv-decision-card-button disabled';
      } else {
        return 'new-uwv-decision-card-button';
      }
    },
    handleClick () {
      if (this.isDisabledPreviousIsReviewing) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('uwv-decision.modals.new-disabled-previous-is-reviewing-title'),
          text: this.$t('uwv-decision.modals.new-disabled-previous-is-reviewing-text')
        });
      } else if (!this.isPreviousApprovedOrReviewing) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Error',
          title: this.$t('uwv-decision.modals.new-disabled-previous-is-not-approved-or-processed-title'),
          text: this.$t('uwv-decision.modals.new-disabled-previous-is-not-approved-or-processed-text')
        });
      } else {
        this.$emit('click');
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.new-uwv-decision-card-button {
  position: relative;
  width: 100%;
  cursor: pointer;
  overflow: hidden;

  border-radius: $border-radius;
  padding: 17px;
  background-color: #1f8cc5;
  line-height: 1.5em;
  min-height: 150px;

  &:hover {
    background-color: #2a97d1;
    .uwv-icon {
      fill: #3da6df;
    }
  }

  .text-container {
    position: absolute;
    bottom: 17px;
  }

  .sub {
    color: $secondary-lighten-4;
  }
  .main {
    color: white;
    font-weight: 700;
    font-size: 1.4em;
  }

  &.disabled {
    background-color: $gray-lighten-2;

    .uwv-icon {
      fill: $gray-lighten-3;
    }

    &:hover{
      background-color: lighten($gray-lighten-2, 2%);
    }

    .sub {
      color: $primary-lighten-1;
    }

    .main {
      color: $primary;
    }
  }
}

.uwv-icon {
  fill: #349ad1;
  top: -20px;
  position: absolute;
  z-index: 0;
  height: 120%;
}

</style>
